class GiftWrapping extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.checkbox = this.querySelector("#gift-wrapping");
    this.settings = JSON.parse(this.querySelector("[data-gift-wrap-settings]").textContent);

    this.checkbox.addEventListener("change", async (event) => {
      if (event.target.checked) {
        await this.addGiftWrappingProduct();
      } else {
        await this.removeGiftWrappingProduct();
      }
    });
    
    document.addEventListener('cart:change', (event) => {
      if (event.detail.cart.items.length === 1 && event.detail.cart.items[0].id === this.settings.variantId) {
        this.removeGiftWrappingProduct();
      }
    });
  }

  cartRefresh() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  }

  async addGiftWrappingProduct() {
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: this.settings.variantId,
        quantity: 1,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        this.cartRefresh();
      })
      .catch((error) => {
        console.error("Error adding gift wrapping product:", error);
      });
  }

  async removeGiftWrappingProduct() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const item = cart.items.find(
          (cartItem) => cartItem.variant_id === this.settings.variantId
        );

        if (item) {
          fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              id: item.key,
              quantity: 0,
            }),
          })
            .then((response) => response.json())
            .then((data) => {
              this.cartRefresh();
            })
            .catch((error) => {
              console.error("Error removing gift wrapping product:", error);
            });
        }
      })
      .catch((error) => {
        console.error("Error retrieving cart:", error);
      });
  }
}

customElements.define("gift-wrapping", GiftWrapping);
